export default "__VITE_ASSET__ae666143__"